import { Subject, Subscription } from 'rxjs';

export class EventListener {
    eventName?: string;
    events?: Subject<Event>;
    eventsSubscription?: Subscription;
    teardownCallback?: () => void;
}
